import api from "@/aygulyazilim/libs/axios"
import { defineStore } from "pinia"

export const useKysTedarikciPerformansStore = defineStore("KysTedarikciPerformansStore", {
  state: () => ({
    kayitlar: [],
    totalKayitlar: 0,
    loading: false,
    tedarikciListesi: [],
  }),

  actions: {
    async fetchKayitlar(params) {
      this.loading = true
      try {
        const res = await api.get("kystedarikciperformans", { params })

        this.kayitlar = res.data.data || []
        this.totalKayitlar = res.data.total || 0
        
        return res.data
      } finally {
        this.loading = false
      }
    },

    async fetchKayitDetay(uuid) {
      this.loading = true
      try {
        const res = await api.get(`kystedarikciperformans/${uuid}`)
        
        return res.data
      } finally {
        this.loading = false
      }
    },

    async saveKayit(payload, uuid = null) {
      this.loading = true
      try {
        if (uuid) {
          return await api.put(`kystedarikciperformans/${uuid}`, payload)
        } else {
          return await api.post("kystedarikciperformans", payload)
        }
      } finally {
        this.loading = false
      }
    },

    async deleteKayit(uuid) {
      this.loading = true
      try {
        return await api.delete(`kystedarikciperformans/${uuid}`)
      } finally {
        this.loading = false
      }
    },

    async downloadExcel(uuid) {
      try {
        const res = await api.get(`kystedarikciperformans/export/${uuid}`, { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')

        link.href = url
        
        // Content-Disposition header reading is complicated in axios without explicit exposure, 
        // fallback to a generic name or parse if available.
        link.setAttribute('download', 'Tedarikci_Performans.xlsx')
        
        document.body.appendChild(link)
        link.click()
        link.parentNode.removeChild(link)
      } catch (error) {
        console.error("Excel indirilemedi", error)
        throw error
      }
    },

    async fetchTedarikciListesi() {
      try {
        const res = await api.get("kystedarikciperformans/tedarikciler/list")

        this.tedarikciListesi = res.data || []
      } catch (error) {
        console.error("Tedarikçi listesi yüklenemedi", error)
      }
    },
  },
})
